<template>
  <div class="d-flex flex-column" style="height:100vh;">
    <appNav></appNav>
    <b-container class="mb-5" id="main-container">
      <router-view></router-view>
    </b-container>
    <appFooter class="mt-auto"/>
  </div>
</template>

<script>
import appNav from './shared/components/header'
import appFooter from './shared/components/footer'
export default {
  components: { appNav, appFooter }
}
</script>

<style lang="scss" scoped>

</style>
